import styled from 'styled-components';

interface IDynamicBadgeProps {
  title: string;
  iconUrl?: string | null;
  textColor?: string | null;
  backgroundColor?: string | null;
}

export const DynamicBadge = ({ title, iconUrl, textColor, backgroundColor }: IDynamicBadgeProps) => {
  return (
    <BadgeContainer textColor={textColor || '#FFFFFF'} backgroundColor={backgroundColor || '#FF3049'}>
      {iconUrl && (
        <BadgeIconWrap>
          <BadgeIcon src={iconUrl} alt={''} />
        </BadgeIconWrap>
      )}
      <BadgeTitle>{title}</BadgeTitle>
    </BadgeContainer>
  );
};

const BadgeContainer = styled.div<{ textColor: string; backgroundColor: string }>`
  height: 28px;

  display: flex;
  align-items: center;

  padding: 8px;
  gap: 2px;

  flex-shrink: 0;

  border-radius: var(--radius-small, 4px);
  background-color: ${(props) => props.backgroundColor};

  color: ${(props) => props.textColor};
  text-align: center;

  /* System/Medium/m-medium */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 85%; /* 11.9px */
`;

/* 시안에서 아이콘 슬롯은 18px인데 아이콘은 20px이라, 오른쪽에 붙여 왼쪽으로 2px 넘치게 그린다 */
const BadgeIconWrap = styled.div`
  width: 18px;

  display: flex;
  justify-content: flex-end;
  align-items: center;

  flex-shrink: 0;
`;

const BadgeIcon = styled.img`
  width: 20px;
  height: 20px;

  flex-shrink: 0;

  object-fit: contain;
`;

const BadgeTitle = styled.span`
  white-space: nowrap;
`;
